var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"organism-head"},[_c('h1',[_vm._v("Plages d'accès")]),_c('AccessFormBtn',{on:{"refresh":function($event){_vm.refresh = !_vm.refresh}}})],1),_c('AccessRuleTable',{key:_vm.refresh})],1)}
var staticRenderFns = []

export { render, staticRenderFns }